import { z } from 'zod';

export const AdFormResponseSchema = z.object({
  isBothSidesIntegration: z.boolean().optional(),
  count: z.object({
    adServer: z.number(),
  }),
  integrations: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      advertiser: z.number().nullable(),
      integrationType: z.literal('ad_server'),
      isActive: z.boolean(),
      platform: z.literal('adform'),
    }),
  ),
});

export const AdFormOptionsResponseSchema = z.object({
  clientId: z.string(),
  redirectUri: z.string(),
  responseType: z.string(),
  scope: z.string(),
  state: z.string(),
});
